import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=8b2ba7a0&lang=pug&"
import script from "./Total.vue?vue&type=script&lang=ts&"
export * from "./Total.vue?vue&type=script&lang=ts&"
import style0 from "./Total.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports